export default __webpack_public_path__ + "static/media/uploader-abbottXtra-2.13b89198.png";